import React from "react";
import ResponsiveCarousel from "../Shared/ResponsiveCarousel";
const Skills = () => {
  return (
    <div className="w-full my-0 px-5 md:px-20  mx-auto py-2">
      <div className="flex md:flex-row flex-col w-full  rounded-lg">
        <div className="flex flex-col  font-roboto justify-center items-center  md:w-[50%]">
          <h6 className="text-green-500 font-bold font-roboto text-3xl ">
            &lt; MY SKILLS / &gt;
          </h6>
          <p className="text-md my-5 px-14 hidden md:block text-white">
          My primary areas of expertise are PHP, Python, and JavaScript. I've
          worked with frontend frameworks such as Vue.js, design frameworks such as Tailwind CSS, Bootstrap,
          and Vuetify, and backend technologies like Laravel, CodeIgniter, and Django. I am enthusiastic about
          myworkandkeentolearn new technologies.
          </p>
        </div>
        <div className="md:w-[50%] md:mx-auto ">
          <ResponsiveCarousel></ResponsiveCarousel>
        </div>
      </div>
    </div>
  );
};

export default Skills;
